angular.module('tf.directives')

    .directive('templateControl', ['$rootScope','$timeout', function ($rootScope, $timeout) {
        return{
            restrict:'E',
            replace:true,
            scope:{
                control : "="
            },
            templateUrl:'js/components/templateControl/templateControl.html',
            link: function(scope,element,attr){

                scope.getRowsCount = function(value){
                    var result = 1;
                    //var arr = value.split("\r");
                    if(value) {
                        var arr = value.split(/[\r\n]+/);
                        result = arr.length;
                    }
                    return result;
                };
                if($rootScope.isMobile) {
                    scope.$watch(function () {
                        return element.height();
                    }, function (newH, oldH) {
                        if (newH !== oldH) {
                            $rootScope.$broadcast("controlHeightChanged");
                        }
                    });
                }
                if(scope.control.ui.type === 'text'){
                    $timeout(function(){
                        autosize($(element).find('textarea'));
                    },1);
                }

                if(scope.control.ui.type === 'slider') {
                    scope.slider = {
                        min: Number(scope.control.ui.args[0]),
                        max: Number(scope.control.ui.args[1]),
                        options: {
                            floor: Number(scope.control.ui.args[0]),
                            ceil: Number(scope.control.ui.args[1]),
                            step: Number(scope.control.ui.args[2]),
                            hideLimitLabels: false,
                            hidePointerLabels: false,
                            boundPointerLabels: false,
                            showSelectionBar: true,
                            showTicks: false,
                            getPointerColor: function (value) {
                                return '#636161';
                            },
                            getSelectionBarColor: function (value) {
                                return '#969595';
                            },
                            onChange: function () {
                                // scope.checkVolumeStatus();
                            }
                        }
                    };
                }

                scope.getSliderTickMarks = function () {
                    var marks = [];
                    for(var i = 0 ; i <= Number(scope.control.ui.args[1]) ; i += Number(scope.control.ui.args[2])){
                        marks.push(i);
                    }
                    return marks;
                };

                scope.menu = {};

            }
        };
    }]);